/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

(function() {
  // Add custom code below this line

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();

function onSwatchClick(x,swatchNum,color) {
  x = x.closest('.radio__fieldset');
  y = document.querySelectorAll('.radio__legend__value');
  y.forEach(element => element.style.visibility = "hidden");
  x.querySelector('.radio__legend__value').style.display = "block";
  x.querySelector('.radio__legend__value').style.visibility = "visible";
  var ultimo = color.slice(-1).replaceAll(" ", "");
  if(ultimo == ''){
    color = color + '2';
  }
  document.getElementById('swatch_valor_'+swatchNum).value = color;

  filterImages()
}

function isMobile() {
  return /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
}

filterImages();

function filterImages(){

  v1 = document.getElementById('swatch_valor_1');
 
  if(v1){
    v2 = document.getElementById('swatch_valor_2');
    v3 = document.getElementById('swatch_valor_3');
    valor1 = v1.value.replaceAll("/", "").replaceAll(" ", "_").replaceAll("ㅤ","-").replaceAll("&", "").replaceAll("(", "").replaceAll(")", "").toLowerCase();

    if(v2){
      var valor2 = v2.value.replaceAll(" ", "_").toLowerCase();;
      var color_filtro = valor1 + '-' + valor2;

      if(v3){
        var valor2 = v2.value.replaceAll(" ", "_").toLowerCase();
        var valor3 = v3.value.replaceAll(" ", "_").toLowerCase();
        var color_filtro = valor1 + '-' + valor2 + '-' + valor3;
      }
    } else {
      var color_filtro = valor1;
    }

    aa = document.querySelectorAll('.i_imagenes');
    aa.forEach(element => element.style.display = "none");

  } else {
    aa = document.querySelectorAll('.i_imagenes');
    aa.forEach(element => element.style.display = "block");

    return false;
  }

  bb = document.querySelectorAll('.'+color_filtro);
  bb.forEach(element => element.style.display = "block");

  // Filtrado de slider
  console.log('COLOR',color_filtro)

  $sliderPdp.slick('slickUnfilter');

  setTimeout(() => {

    if (isMobile()) {
      $sliderPdp.slick('slickFilter', function (index, slide) {
        // Obtener categorías del slide
        var categories = $(slide).data('category').split(' ');
        // Verificar si el filtro está incluido
        return categories.includes(color_filtro);
      });
      $sliderPdp.slick('slickGoTo', 0, true);
    } else {

      aa2 = document.querySelector('.pdp-slider').querySelectorAll('.item');
      aa2.forEach(element => element.style.display = "none");

      bb4 = document.querySelector('.pdp-slider').querySelectorAll('.item[data-category*="' + color_filtro + '"]');
      bb4.forEach(element => element.style.display = "block");

      console.log("Estás en un escritorio.");
    }

  }, 200);
 
}

function onCollectionSwatchClick(x){
  var comparePrice = x.getAttribute('data-swatch-compare-price');
  var salePrice = x.closest('.product-item__info');
  salePrice = salePrice.querySelector('.old-price span.money');
  if (!salePrice) {
    salePrice = x.closest('.product-item__info');
    salePrice = salePrice.querySelector('span.old-price');
    salePrice.innerText = Shopify.formatMoney(comparePrice, "${{amount}}");
  }
  else {
  salePrice.innerText = Shopify.formatMoney(comparePrice, "$ {{amount}} CAD");
  }
}

function mouseOver(x) {
  if (x.querySelector(".is-visible img.featured-alt")){
  if (!x.querySelector(".is-visible figure")){
  x.querySelector(".product-item__bg figure").style.display = "none";
  } else {
  x.querySelector(".is-visible figure").style.display = "none";
  }
  }
}

function mouseOut(x) {
  if (x.querySelector(".is-visible img.featured-alt")){
  if (!x.querySelector(".is-visible figure")){
  x.querySelector(".product-item__bg figure").style.display = "block";
  } else {
  x.querySelector(".is-visible figure").style.display = "block";
  }
  }
}

function youtooSelection(x) {
  if (x == 'fabric'){
    document.getElementById('leather-combo').style.display = "none";
    document.querySelector('.selector-wrapper.selector-wrapper--fullwidth[data-option-position="2"] .radio__fieldset.radio__fieldset--swatches').style.display = "grid";
    document.getElementById('leather-selection').checked = false;
    document.getElementById('fabric-selection').checked = true;
  }
  if (x == 'leather'){
    document.getElementById('leather-combo').style.display = "grid";
    document.querySelector('.selector-wrapper.selector-wrapper--fullwidth[data-option-position="2"] .radio__fieldset.radio__fieldset--swatches').style.display = "none";
    document.getElementById('leather-selection').checked = true;
    document.getElementById('fabric-selection').checked = false;
  }
}

document.addEventListener('DOMContentLoaded', function () {
    // Check if the current URL contains /en-us
    if (window.location.pathname.includes('/en-us')) {
        // Get all anchor tags
        const links = document.querySelectorAll('a');
      
        links.forEach(link => {
            // Check if the href attribute matches the specific URL
            if (link.href === 'https://ergonofis.com/products/foldable-walking-treadmill-for-standing-desk' || link.href === 'https://ergonofis.com/en-us/products/foldable-walking-treadmill-for-standing-desk') {
                // Change the href attribute
                link.href = 'https://ergonofis.com/en-us/products/foldable-walking-treadmill';
            }
        });
    }
});